import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Text, Link, FlexPanel, Divider } from 'Common';
import { showToast } from 'Utils/toastUtils';
import { t } from 'Utils/localization/i18next';
import { getRedirectURLForUpdatePassword } from 'Redux/profile/profileThunks';
import styles from './DashboardSectionReadContainer.module.scss';

class DashboardPasswordSectionReadContainer extends React.PureComponent {
  onEdit = async () => {
    const redirectURL = await this.props.getRedirectURLForUpdatePassword();
    if (redirectURL) {
      window.location = redirectURL;
    } else {
      showToast(t('forms.errors.title'), `- ${t('forms.errors.generic')}`);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className={styles['dashboard-section-read']}>
          <FlexPanel spread className={styles['dashboard-section-read-title']}>
            <Text bold colour="grey-900">
              {t(this.props.title)}
            </Text>
            <Link
              bold
              underline
              colour="grey-900"
              id="password-ciam-edit-link"
              onClick={this.onEdit}
            >
              {t('common.edit')}
            </Link>
          </FlexPanel>
          {this.props.children}
        </div>
        {!this.props.isLastElement && <Divider dashboard />}
      </React.Fragment>
    );
  }
}

DashboardPasswordSectionReadContainer.propTypes = {
  title: PropTypes.string,
  isLastElement: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  // From Redux/Thunks
  getRedirectURLForUpdatePassword: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getRedirectURLForUpdatePassword }, dispatch);
};

export default connect(
  null,
  mapDispatchToProps
)(DashboardPasswordSectionReadContainer);
